/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { Row, Col, Tooltip } from "reactstrap";
// import { serverEndpoint } from "utils/serverEndpoint";
import SvgIcon from "react-icons-kit";
import { plus } from "react-icons-kit/icomoon/plus";
import { cross } from "react-icons-kit/icomoon/cross";
import * as extensionImage from "../../../images/FileTypes";
import { processFileExtension } from "../helperFunctions";
import { getServerEndpoint } from "../../../utils/serverEndpoint";
import { languageService } from "../../../Language/language.service";
import { themeService } from "theme/service/activeTheme.service";
import { basicColors, retroColors, electricColors } from "../../../style/basic/basicColors";
import { fetchStaticResource, sanitizedFilename } from "../../../utils/utils";
import ConfirmationDialog from "components/Common/ConfirmationDialog";
class DocumentsArea extends Component {
  render() {
    const { documentList, disallowDelete, deleteDocument, disableHeader, acctionBtn, addDocument } = this.props;

    const showDocuments = documentList.map((doc, index) => {
      if (!doc) return null;

      return (
        <div
          key={doc + index}
          style={{
            margin: "0",
            cursor: "pointer",
            fontSize: "12px",
            width: "fit-content",
            boxSizing: "border-box",
          }}
        >
          <DocumentComp
            index={index}
            docName={doc}
            borderStyle={"1px solid var(--first)"}
            width={"100%"}
            disallowDelete={disallowDelete}
            deleteDocument={deleteDocument}
          />
        </div>
      );
    });

    return (
      <Row>
        {/* Header */}
        <Col md={12}>
          <h5
            style={themeService({
              default: { padding: "10px 0px", font: "18px sans-serif", color: "var(--first)" },
              retro: { padding: "10px 0px", font: "18px sans-serif", color: "var(--second)" },
              electric: { padding: "10px 0px", font: "18px sans-serif", color: electricColors.second },
            })}
          >
            {!disableHeader && languageService("Documents")}
          </h5>
        </Col>

        {/* Main content area */}
        {acctionBtn ? (
          <React.Fragment>
            {/* Document area - 10/12 width */}
            <Col md={10}>
              <div
                className="scrollbarHor"
                style={themeService({
                  default: {
                    overflow: "auto",
                    whiteSpace: "nowrap",
                    border: "1px solid rgb(13, 117, 119)",
                    height: "150px",
                    paddingLeft: "26px",
                  },
                  retro: {
                    overflowX: "auto",
                    overflowY: "hidden",
                    height: "150px",
                    paddingLeft: "26px",
                    background: "var(--fifth)",
                  },
                  electric: {
                    overflow: "auto",
                    whiteSpace: "nowrap",
                    border: "1px solid" + electricColors.fourth,
                    height: "150px",
                    paddingLeft: "26px",
                    background: electricColors.fifth,
                  },
                })}
              >
                <div
                  style={{
                    display: "grid",
                    gridAutoFlow: "column",
                    gridTemplateRows: "repeat(2, 1fr)",
                    gap: "10px",
                  }}
                >
                  {showDocuments}
                </div>
              </div>
            </Col>

            {/* Icon area - 2/12 width */}
            <Col md={2} style={{ padding: "0px" }}>
              <div
                style={themeService({
                  default: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--first)", cursor: "pointer" },
                  retro: { padding: "15px 0px", margin: "auto", width: "50%", color: "var(--second)", cursor: "pointer" },
                  electric: { padding: "15px 0px", margin: "auto", width: "50%", color: electricColors.second, cursor: "pointer" },
                })}
              >
                <SvgIcon onClick={addDocument} icon={plus} size={20} />
              </div>
            </Col>
          </React.Fragment>
        ) : (
          // Full width document area when no icon
          <Col md={12}>
            <div
              className="scrollbarHor"
              style={themeService({
                default: {
                  overflow: "auto",
                  whiteSpace: "nowrap",
                  border: "1px solid rgb(13, 117, 119)",
                  height: "150px",
                  paddingLeft: "26px",
                },
                retro: {
                  overflowX: "auto",
                  overflowY: "hidden",
                  height: "150px",
                  paddingLeft: "26px",
                  background: "var(--fifth)",
                },
                electric: {
                  overflow: "auto",
                  whiteSpace: "nowrap",
                  border: "1px solid" + electricColors.fourth,
                  height: "150px",
                  paddingLeft: "26px",
                  background: electricColors.fifth,
                },
              })}
            >
              <div
                style={{
                  display: "grid",
                  gridAutoFlow: "column",
                  gridTemplateRows: "repeat(2, 1fr)",
                  gap: "10px",
                }}
              >
                {showDocuments}
              </div>
            </div>
          </Col>
        )}
      </Row>
    );
  }
}

export default DocumentsArea;

class DocumentComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltip: null,
      confirmationDialog: false,
      documentUrl: null,
    };
    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this);
  }

  componentDidMount() {
    this.loadDocument();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.docName !== this.props.docName) {
      this.loadDocument();
    }
  }

  async loadDocument() {
    try {
      const response = await fetchStaticResource(`${getServerEndpoint()}assetDocuments/${sanitizedFilename(this.props.docName)}`);

      this.setState({ documentUrl: response });
    } catch (error) {
      console.error("Error fetching document:", error);
    }
  }

  toggleTooltip = (tooltip) => {
    this.setState({ tooltip: this.state.tooltip ? null : tooltip });
  };

  handleConfirmation = (deleteDocument) => {
    if (deleteDocument) {
      this.props.deleteDocument(this.props.docName, this.props.index);
    }
    this.setState({ confirmationDialog: false });
  };

  handleConfirmationToggle = () => {
    this.setState({ confirmationDialog: false });
  };

  render() {
    let [documentName, extension] = this.props.docName.split(".");
    extension = processFileExtension(this.props.docName);

    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        {this.state.documentUrl ? (
          <a
            id={`doc_${this.props.index + 1}`}
            style={{
              padding: "0",
              display: "inline-block",
              verticalAlign: "top",
            }}
            href={this.state.documentUrl}
            download={this.props.docName}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={extensionImage[extension]}
              style={{ display: "block", marginLeft: "auto", marginRight: "auto", width: "44px", padding: "5px" }}
              alt={extension}
            />
            <Tooltip
              isOpen={this.state.tooltip !== null && this.state.tooltip === this.props.index + 1}
              target={`doc_${this.props.index + 1}`}
              toggle={() => this.toggleTooltip(this.props.index + 1)}
              placement={this.props.index < 3 ? "top" : "bottom"}
            >
              {languageService(documentName)}
            </Tooltip>
          </a>
        ) : (
          <span>Loading...</span>
        )}

        {!this.props.disallowDelete && (
          <SvgIcon
            icon={cross}
            size={18}
            style={{ marginLeft: "auto", marginRight: "auto", display: "block", cursor: "pointer", color: "#840F0F" }}
            onClick={() => {
              this.setState({ confirmationDialog: true });
            }}
          />
        )}

        <ConfirmationDialog
          modal={this.state.confirmationDialog}
          toggle={this.handleConfirmationToggle}
          handleResponse={this.handleConfirmation}
          confirmationMessage={`${languageService("Are you sure you want to remove: ")} ${this.props.docName}?`}
          headerText={languageService("Confirm Removal")}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/DocumentsArea/index.jsx